import React from 'react';
import { Button } from './ui/button';
import { RescheduleModal } from './RescheduleModal';
import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { Appointment, SchedulePillProps } from '../types/appointments';

export const SchedulePill: React.FC<SchedulePillProps> = ({ 
  appointment, 
  status, 
  date, 
  time, 
  completedDate, 
  onReschedule,
  onSuccess,
  // New props for handling report vs call dates
  reportDate,
  callDate,
  hasReport = false
}) => {
  // Determine which date to show based on availability
  const displayDate = hasReport ? reportDate : callDate;
  const isCompleted = hasReport && reportDate;


  if (isCompleted) {
    return (
      <div className="text-right flex-shrink-0 ml-auto">
        <div className="font-medium text-foreground">Completed</div>
        <div className="text-sm text-muted-foreground">{displayDate}</div>
      </div>
    );
  }

  if (status === 'scheduled') {
    // Format appointment date and time for display in UTC
    const formatAppointmentDateTime = (scheduledAt: string) => {
      try {
        const date = parseISO(scheduledAt);
        return {
          date: formatInTimeZone(date, 'UTC', 'MMMM do'),
          time: formatInTimeZone(date, 'UTC', 'h:mm a')
        };
      } catch {
        return { date: 'Invalid date', time: 'Invalid time' };
      }
    };

    const displayData = appointment?.scheduledAt ? 
      formatAppointmentDateTime(appointment.scheduledAt) : 
      { date: '', time: '' };

    return (
      <div className="text-right space-y-1 flex-shrink-0 ml-auto">
        <div className="font-medium text-foreground">Scheduled</div>
        <div className="text-sm text-muted-foreground">{displayData.date} at {displayData.time}</div>
        <RescheduleModal 
          appointment={appointment as Appointment}
          currentDate={date} 
          currentTime={time} 
          onReschedule={onReschedule}
          onSuccess={onSuccess}
        >
          <Button variant="ghost" size="sm" className="h-6 px-2 text-xs text-primary hover:text-primary/80 mt-1">
            Change
          </Button>
        </RescheduleModal>
      </div>
    );
  }

  // Show schedule option for intake types that don't have reports yet
  if (!hasReport && appointment?.type && ['INTAKE1', 'INTAKE2', 'INTAKE3'].includes(appointment.type)) {
    return (
      <div className="text-right flex-shrink-0 ml-auto">
        <div className="font-medium text-gray-900">Not scheduled</div>
        <RescheduleModal 
          appointment={appointment as Appointment}
          currentDate={date} 
          currentTime={time} 
          onReschedule={onReschedule}
          onSuccess={onSuccess}
        >
          <Button variant="ghost" size="sm" className="h-6 px-2 text-xs text-primary hover:text-primary/80 mt-1"
          disabled={true}
          >
            Schedule
          </Button>
        </RescheduleModal>
      </div>
    );
  }

  return (
    <div className="text-right flex-shrink-0 ml-auto">
    <div className="font-medium text-foreground">Not scheduled</div>
  </div>
  );
};
